'use client';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { setShadowRootStyle } from '../../common';
import { SELECTED_STORE_ID } from '../constants';
export const DealerLocatorSearchResults = ({ children, visibleStores }) => {
    // Fixing style issues inside shadow-root of Blocks components
    const searchResults = document.getElementsByName(SELECTED_STORE_ID);
    const areResultsLoaded = searchResults.length === visibleStores.length;
    useEffect(() => {
        if (areResultsLoaded) {
            searchResults?.forEach((element) => {
                // Fix background color on radio button label on hover
                setShadowRootStyle(element, 'label', 'background-color', 'unset');
            });
        }
    }, [areResultsLoaded, searchResults]);
    return _jsx(_Fragment, { children: visibleStores.map((store) => children({ store })) });
};
